export default "__VITE_PUBLIC_ASSET__43f0533a__"